import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';

export type RawLearningBlock = {
  id: string;
  title: string;
  itemIds: string[];
  estimatedDuration?: number;
};

export type TimeCommitment = 15 | 30 | 45 | 60;

export const DEFAULT_TIME_COMMITMENT: TimeCommitment = 30;

export const TIME_COMMITMENT_OPTIONS: TimeCommitment[] = [15, 30, 45, 60];

export type LearningPace = 'guided' | 'low' | 'high';

export const DEFAULT_LEARNING_PACE: LearningPace = 'low';

export const LEARNING_PACE_TO_INDEX: Record<LearningPace, 0 | 1 | 2> = {
  guided: 0,
  low: 1,
  high: 2,
};

export const INDEX_TO_LEARNING_PACE: readonly LearningPace[] = ['guided', 'low', 'high'];

export type BlockItem = {
  itemId: string;
  itemMetadata: ItemMetadata;
};

export type LearningBlock = RawLearningBlock & {
  items: BlockItem[];
};

export type AdaptiveLearningPlan = {
  blocks: LearningBlock[];
  timeCommitment: TimeCommitment;
  learningPace: LearningPace;
};
